import { useState } from 'react';
import dayjs from '@/helpers/dayjs';
import PeriodPopover from './periodPopover';

function ChoiceByDay({
  item, calendarCurrent = {}, store, onPick,
}) {
  const [openPopover, setOpenPopover] = useState(false);

  const dateCurrent = dayjs(item.date);

  const fnPeriodAvailable = () => {
    const available = {
      d: true, m: true, a: true, n: true, disabled: '',
    };

    return available;
  };

  const fnDateIsSelected = () => store.getDatesPicked().indexOf(dateCurrent.formatAsKey()) > -1;
  // garbage function, juste for dev
  const getPeriodDateCurrent = () => store.getPeriod()[dateCurrent.formatAsKey()];

  const fnDateIsDisable = () => {
    // datecurrent isover
    if (store.isPast(dateCurrent)) return true;
    // datecurrent isn't same current month
    if (!dateCurrent.isSame(calendarCurrent.date, 'months')) return true;
    // day of week not filled
    return false;
  };

  const periodAvailable = fnPeriodAvailable();
  // if no available period => day disable, else check fnDateIsDisable
  const dateIsDisable = !(periodAvailable.disabled !== true) || fnDateIsDisable();
  const dateIsSelected = fnDateIsSelected();
  const classes = `cursor-pointer relative day text-center ${periodAvailable.disabled === true
    ? ''
    : periodAvailable.disabled}`;

  const onClickDay = () => {
    setOpenPopover(true);
  };

  function renderPopover() {
    if (!openPopover) return null;
    return (
      <PeriodPopover
        {...{
          item, periodAvailable, store, onPick,
        }}
        onClose={() => {
          setOpenPopover(false);
        }}
      />
    );
  }

  return (
    <td
      data-selected={dateIsSelected}
      data-disabled={dateIsDisable}
      className={classes}
    >
      <div className="flex items-center justify-center">
        <div
          className={`flex period-${getPeriodDateCurrent()} items-center justify-center h-9 w-9 block rounded-lg hover:bg-purple-1/70 hover:text-purple-6 transition-all duration-200 ease-in-out ${openPopover ? 'bg-purple-1/50' : ''} ${dateIsDisable ? 'text-purple-2 bg-white' : 'text-purple-5 '}`}
          {...(dateIsDisable ? {} : { onClick: onClickDay })}
        >
          <span>
            {dateCurrent.date()}
            {dateIsSelected}
          </span>
        </div>
      </div>
      {renderPopover()}
    </td>
  );
}

export default ChoiceByDay;
